import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { articles } from '../mock';
import Article1 from './articles/Article1';

const ArticlePage = () => {
  const { articleId } = useParams();
  const article = articles.find(a => a.id === parseInt(articleId));

  if (!article) {
    return (
      <div className="page-container">
        <h1 className="page-title">
          <span className="text-red">[</span>404 - Article Not Found<span className="text-red">]</span>
        </h1>
        <Link to="/blog" className="text-cyan hover:underline">&lt; Back to Blog</Link>
      </div>
    );
  }

  let ArticleComponent;
  switch (parseInt(articleId)) {
    case 1:
      ArticleComponent = <Article1 />;
      break;
    default:
      // Handle cases for other articles if they exist, or a fallback.
      ArticleComponent = (
        <div>
          <p>Article content coming soon.</p>
        </div>
      );
  }

  return (
    <div className="page-container article-page">
      {ArticleComponent}
      
      <div className="terminal-hint-bottom">
         <Link to="/blog" className="flex items-center text-cyan hover:underline">
            <ArrowLeft size={16} className="mr-2" />
            cd ../
         </Link>
      </div>
    </div>
  );
};

export default ArticlePage;
